import CONSTANT from '@/constant'
import { BACKOFFICE_USER_PAGE } from '@/constant/BACKOFFICE_PERMISSION'

export const routes: Array<{ path: string; isAuth: boolean; pageCode?: string[]; order?: number }> =
  [
    {
      path: CONSTANT.PATHNAME.STAR,
      isAuth: false,
      pageCode: undefined,
    },
    {
      path: CONSTANT.ROUTES.LOGIN_PAGE,
      isAuth: false,
      pageCode: undefined,
    },
    {
      path: CONSTANT.ROUTES.PASSWORD_FORGOT_PAGE,
      isAuth: false,
      pageCode: undefined,
    },
    {
      path: CONSTANT.ROUTES.PASSWORD_RESET_PAGE,
      isAuth: false,
      pageCode: undefined,
    },
    {
      path: CONSTANT.ROUTES.CONFIRM_EMAIL_PAGE,
      isAuth: false,
      pageCode: undefined,
    },
    {
      path: CONSTANT.ROUTES.TVI_CONNECT_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.MTD0101],
      order: 3,
    },
    {
      path: CONSTANT.ROUTES.EV_CHARGING_STATION_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.MTD0101],
      order: 4,
    },
    {
      path: CONSTANT.PATHNAME.POLICY_DETAIL,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.CUS0101, BACKOFFICE_USER_PAGE.MTP0101],
      order: 1,
    },
    {
      path: CONSTANT.ROUTES.REPORT_PAGE,
      isAuth: true,
      pageCode: undefined,
      order: 99, // will be always the last order.
    },
    {
      path: CONSTANT.ROUTES.WELCOME_CALL_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.WEL0101],
      order: 8,
    },
    {
      path: CONSTANT.ROUTES.POLICY_MANAGEMENT_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.POL0101],
      order: 9,
    },
    {
      path: CONSTANT.ROUTES.DISCOUNT_ISSUE_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.DIS0101],
      order: 10,
    },
    {
      path: CONSTANT.ROUTES.WATCH_MANAGEMENT_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.WAT0101],
      order: 11,
    },
    {
      path: CONSTANT.ROUTES.CAMPAIGN_MANAGEMENT_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.CAM0101],
      order: 12,
    },
    {
      path: CONSTANT.ROUTES.HELP_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.HEL0101],
      order: 16,
    },
    {
      path: CONSTANT.ROUTES.FREQUENCY_QUESTIONS_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.FAQ0101],
      order: 18,
    },
    {
      path: CONSTANT.ROUTES.USER_PERMISSION_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.USR0101],
      order: 20,
    },
    {
      path: CONSTANT.ROUTES.WELL_BEING_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.WBE0101],
      order: 17,
    },
    {
      path: CONSTANT.ROUTES.TA_TRANSACTION_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.TA0101],
      order: 19,
    },
    {
      path: CONSTANT.ROUTES.RETURN_TIME_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.MTA0101],
      order: 5,
    },
    {
      path: CONSTANT.ROUTES.TVI_CONNECT_CHECK_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.MTD0201],
      order: 6,
    },
    {
      path: CONSTANT.ROUTES.DOPA_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.DOP0101],
      order: 2,
    },
    {
      path: CONSTANT.ROUTES.AUTO_ASSIGN_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.AAS0101],
      order: 14,
    },
    {
      path: CONSTANT.ROUTES.HEALTH_CLAIM_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.CLM0101],
      order: 13,
    },
    {
      path: CONSTANT.ROUTES.HEALTH_CLAIM_APPROVAL,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.APP0101],
      order: 15,
    },
    {
      path: CONSTANT.ROUTES.CRASH_DETECTION_PAGE,
      isAuth: true,
      pageCode: [BACKOFFICE_USER_PAGE.CRS0101],
      order: 7,
    },
    {
      path: CONSTANT.ROUTES.USER_NOT_FOUND_PAGE,
      isAuth: false,
      pageCode: undefined,
    },
  ]

/**
 * Resolve the landing path after login: among the authenticated routes the
 * user is allowed to reach (their `pages` intersect the route's `pageCode`),
 * pick the one with the lowest `order`. `order` mirrors the sidebar menu
 * traversal (menu-by-menu, submenu-by-submenu), so the user lands on the
 * highest-priority page they can access. Routes without an `order` are never
 * chosen as a landing target. Falls back to the unauthorized page when the
 * user has no orderable page that maps to a known route.
 */
export const resolveLandingPath = (pages?: Array<string>): string => {
  const allowed = Array.isArray(pages) ? pages : []

  const target = routes
    .filter(
      (route) =>
        route.isAuth &&
        typeof route.order === 'number' &&
        route.pageCode?.some((code) => allowed.includes(code)),
    )
    .sort((a, b) => (a.order as number) - (b.order as number))[0]

  return target?.path ?? CONSTANT.ROUTES.UNAUTHORIZED_PAGE
}
